import React, { useState,useEffect } from 'react';
import axios from 'axios'
import CommonVars from '../Component/CommonVars';
import {
    Flex,
    Box,
    Image,
    Heading,
    VStack,
    Button,
    Link
  } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

function CartScreen () {
    const [carts,setCarts] = useState('')
    useEffect(() => {
        getCarts();
    },[])
    const userid = localStorage.getItem('loggedInUserID');

    const getCarts = async() => {
        axios.get(`${CommonVars.API_URL}/carts/${userid}`)
        .then((res) =>{
            console.log(res);
            const cartsData = res.data;
            console.log(cartsData)
            setCarts(cartsData)
        }).catch((err) =>{
            console.log(err)
        })
    }
    // const DeleteItem = async()=>{
    //     console.log(userid);
    //     axios.delete(`${CommonVars.API_URL}/carts/${userid}/${}`)
    //     .then((res) =>{
    //         console.log(res)
    //     })
    // }
    
  

    const aCarts = []
    for(var i = 0; i <carts.length; i++)
    {
        aCarts.push(
            <Box key={carts[i].cartid} margin={'1'} boxShadow={'dark-lg'} w={'850px'} bg={'white'}>
         
                <Flex>
                    <Box>
                        <Image boxSize={'150'} src={carts[i].image}/>
                    </Box>
                    <Box marginRight={'5'}>
                        <VStack >
                            <Box marginTop={'5'} fontWeight={'semibold'} fontSize={'2xl'}>
                                {carts[i].name}
                            </Box>
                            <Flex>
                                <Box marginInlineStart={'3'} fontWeight={'semibold'}>
                                Quantity: 
                                </Box>
                                <Box  fontWeight={'semibold'} marginInline={'5'}>
                                {carts[i].quantity}
                                </Box>
                            </Flex>
                            <Flex>
                                <Box marginInlineStart={'3'} fontWeight={'semibold'}>
                                Total: 
                                </Box>
                                <Box fontWeight={'semibold'} marginInline={'5'}>
                                ${carts[i].total}
                                </Box>
                            </Flex>
                        </VStack>

                    </Box>
                    <Box marginInlineStart={'80'} marginTop={'50'}>
                        <Button   bg={'gray.100'}>
                            <Link href={`/carts/${userid}/${carts[i].cartid}`}>
                            View Detail
                            </Link>
                           
                        </Button>              
                    </Box>             
                </Flex>            
            </Box>
                      
            )
           

    }
  

    return (
        <Box  bg={'gray.100'}>
            <Heading>Cart Screen</Heading>
            <Box marginInline={'300'}>
            {aCarts}
            </Box>
            
        </Box>
    )
}

export default CartScreen;